import React from 'react';

import HeroSection from './HeroSection';
import InfoSection from './InfoSection';

function HomePage() {
  return (
    <>
      <HeroSection />
      <InfoSection />
    </>
  );
}

export default HomePage;
